<template>
    <div>
        <config-main-title>
            Log de Alterações 

            <template v-slot:right>
                <!-- Default dropleft button -->
                <div class="btn-group dropleft" v-if="stack.length">
                    <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Histórico
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#" v-for="(item, iix) in stack" :key="iix" @click.prevent="voltar(iix)">
                            {{ item.title }} #{{ item.id }}
                        </a>
                    </div>
                </div>
            </template>
        </config-main-title>
        
        <!--
        <hr>
        <a href="#" @click.prevent="load ()" class="card-link">Recarregar</a>
        <a href="#" @click.prevent="log ()" class="card-link">Log</a>
        <a href="#" @click.prevent="$router.go(-1)" class="card-link">Voltar</a>
        <hr>
        -->
        
        <az-empty-state v-if="!dados" />

        <div v-if="dados" class="card">
            <div class="card-header d-flex justify-content-between">
                <span>
                    {{ dados.title }} #{{ id }}
                </span>
                
                <span v-if="dados.item.search" class="text-right">
                    {{ dados.item.search }}
                </span>
                <span v-else-if="$store.state.user.id_usuario == 1">
                    {{ model }} / {{ id }}
                </span>
            </div>
            <div class="card-body">
                <table class="table table-sm table-responsive-md table-hover">
                    <thead>
                        <th>Campo</th>
                        <th>Valor Atual</th>
                    </thead>
                    <tbody>
                        <template v-if="campos">
                            <template v-for="(valor, campo, icx) in atual">
                                <tr :key="campo" v-if="!icx || campos[campo]">
                                    <td>{{ tratarCampo(campo) }}</td>
                                    <td>
                                        <span>
                                            {{ tratarValor(campo, valor) }}
                                        </span>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <template v-else>
                            <tr v-for="(valor, campo) in atual" :key="campo">
                                <td>{{ tratarCampo(campo) }}</td>
                                <td>
                                    <router-link :to="valorLink(campo, valor)" v-if="false && valorLink(campo, valor)">
                                        {{ valor }}
                                    </router-link>
                                    <a href="#" class="card-link" @click.prevent="abrir(campo, valor)" v-if="valorLink(campo, valor)">
                                        {{ valor }}
                                    </a>
                                    <span v-else>
                                        {{ tratarValor(campo, valor) }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="card-body">
                <table class="table table-hover table-responsive-md">
                    <thead>
                        <th>Campo</th>
                        <th>Valor Anterior</th>
                        <th>Novo Valor</th>
                    </thead>
                    <tbody>
                        <template v-for="(audit, iaud) in dados.audits">
                            <template v-if="!campos || check_campos(audit)">
                                <tr :key="iaud">
                                    <th class="table-info" colspan="3">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <span class="byline">
                                                    <a href="#" @click.prevent="redirect (audit.model, audit.auditable_id)" 
                                                        v-if="audit.model != model">
                                                        {{ audit.title }}
                                                    </a>
                                                    <span v-else>
                                                        {{ audit.title }}
                                                    </span>
                                                </span>
                                                <div class="time-ago">
                                                    <small>
                                                        <span v-if="audit.user">
                                                            Alterado por 
                                                            <strong>
                                                                {{ audit.user.search }}
                                                            </strong>
                                                        </span>
                                                        em 
                                                        <strong v-if="audit.updated_at">
                                                            {{ $util.getFormatDate(audit.updated_at) }} 
                                                            {{ audit.updated_at.substr(11,8) }} 
                                                        </strong>

                                                        <span class="text-muted ml-3">
                                                            {{ duracao(audit.updated_at) }} 
                                                        </span>
                                                    </small>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="small text-muted">IP: {{ audit.ip_address }}</div>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <template v-if="audit.event == 'created'">
                                    <tr :key="iaud + '-items' + campo" v-for="(valor, campo) in audit.new_values">
                                        <td>
                                            {{ tratarCampo(campo) }}
                                        </td>
                                        <td>
                                            [Novo]
                                        </td>
                                        <td>
                                            <a href="#" class="card-link" @click.prevent="abrir(campo, valor)" v-if="valorLink(campo, valor)">
                                                {{ valor }}
                                            </a>
                                            <span v-else>
                                                {{ tratarValor(campo, valor) }}
                                            </span>
                                        </td>
                                    </tr>
                                </template>
                                <template v-if="audit.event == 'deleted'">
                                    <tr :key="iaud + '-items' + campo" v-for="(valor, campo) in audit.old_values">
                                        <td>
                                            {{ tratarCampo(campo) }}
                                        </td>
                                        <td>
                                            <a href="#" class="card-link" @click.prevent="abrir(campo, valor)" v-if="valorLink(campo, valor)">
                                                {{ valor }}
                                            </a>
                                            <span v-else>
                                                {{ tratarValor(campo, valor) }}
                                            </span>
                                        </td>
                                        <td>
                                            [Excluído]
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr :key="iaud + '-items' + campo" v-for="(valor, campo) in audit.old_values">
                                        <td>
                                            {{ tratarCampo(campo) }}
                                        </td>
                                        <td>
                                            <a href="#" @click.prevent="abrir_json(valor)" v-if="is_json_array(valor)" class="mr-2">
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </a>

                                            <a href="#" class="card-link" @click.prevent="abrir(campo, valor)" v-if="valorLink(campo, valor)">
                                                {{ valor }}
                                            </a>

                                            <span v-else>
                                                {{ tratarValor(campo, valor) }}
                                            </span>
                                        </td>
                                        <td>
                                            <a href="#" @click.prevent="abrir_json(audit.new_values[campo])" v-if="is_json_array(audit.new_values[campo])" class="mr-2">
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </a>

                                            <a href="#" class="card-link" @click.prevent="abrir(campo, audit.new_values[campo])" v-if="valorLink(campo, audit.new_values[campo])">
                                                {{ audit.new_values[campo] }}
                                            </a>
                                            
                                            <span v-else>
                                                {{ tratarValor(campo, audit.new_values[campo]) }}
                                            </span>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <br><br>

        <nav class="navbar fixed-bottom navbar-light bg-light">
            <a href="#" @click.prevent="voltar()" class="btn btn-secondary">Voltar</a>
        </nav>

        <!--- Modal Visualização Json -->
        <div class="modal fade" id="auditJsonModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Visualizar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="json_form">
                            <formulario 
                                v-model="dado_json" 
                                mode="view" />
                        </div>
                        <template v-else>
                            <pre>{{ dado_json }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Formulario from '../../modulos/consultorio/Formulario.vue';

export default {
    data () { 
        return { 
            dados: null, 
            model: null, 
            id: null, 
            stack: [], 
            campos: null, 
            dado_json: null, 
            json_form: false
        }
    },

    components: { 
        ConfigMainTitle,
        AzEmptyState, 
        Formulario, 
    },

    watch: { 
        $route: function () { 
            this.load();
        }
    },

    computed: { 
        atual: function () { 
            return this.dados ? _.omitBy(this.dados.item, function(value, key) {
                return value === null || typeof value == 'object' || key.charAt(2) != '_';
            }) : [];
        }
    },

    methods: { 
        abrir_json (valor) { 
            this.json_form = false; 
            this.dado_json = JSON.parse(valor);
            this.json_form = _.get(this.dado_json, '0.type') ? true : false; 
            
            $('#auditJsonModal').modal('show');
        },

        is_json_array(valor) {
            if ( valor && ( typeof valor == 'string' ) ) { 
                if ( valor.slice(0,2) == '[{' && valor.slice(-2) == '}]' ) { 
                    return true; 
                }
            }

            return false; 
        },

        check_campos (audit) { 
            if ( audit.new_values ) { 
                if ( _.intersection(_.keys(audit.new_values), _.keys(this.campos)).length ) { 
                    return true;
                }
            }

            return false;
        },

        duracao (data) { 
            return moment
                .duration(moment(data, "YYYY-MM-DD HH:mm:ss").diff())
                .humanize(true);
        },

        voltar (index = null) { 
            let item;

            if ( index !== null ) { 
                item = this.stack[index];
                this.stack.splice(index);    
            } else { 
                item = this.stack.pop();
            }

            if ( item && item.model && item.id ) { 

                this.dados = null;
                this.model = item.model;
                this.id = item.id;

                this.load();

                return;

            }

            this.$router.go(-1);
        },

        abrir (campo, valor) { 

            if ( campo && campo.substr(0,3) == 'id_' && campo.substr(-4,4) != '_mae' ) { 
                this.stack.push({ 
                    model: this.model,
                    id: this.id, 
                    title: this.dados.title,
                });

                if ( campo && campo.substr(0,3) == 'id_' && campo.substr(0,10) == 'id_usuario' ) { 
                    this.model = 'usuario';
                } else { 
                    this.model = _.camelCase(campo.substr(3));
                }

                this.dados = null;
                this.id = valor;

                this.load();
            }

        },

        tratarCampo (campo) { 
            switch (campo) {
                case 'model_type': return 'origem';
                case 'model_id': return 'id';
            }

            return campo.substr(3).replace('_', ' ');
        },

        tratarValor (campo, valor) { 

            if ( campo == 'model_type' && valor && valor.substr(0,10) == 'App\\azure\\' ) { 
                return valor.substr(10);
            }

            if ( campo && campo.substr(0,3) == "fl_" && valor != null ) { 
                return ( valor == "0" || !valor ) ? 'Não' : 'Sim';
            } else if ( campo && campo.substr(0,3) == "dt_" && valor != null ) { 
                return this.$util.getFormatDate(valor) + ( valor.substr(11,8) == '00:00:00' ?  "" : ( ' ' + valor.substr(11,8) ) );
            }

            return valor;
        },

        valorLink (campo, valor) { 
            if ( campo && campo.substr(0,3) == 'id_' && campo.substr(0,10) == 'id_usuario' ) { 
                return '/audits/usuario/' + valor;
            } else if ( campo && campo.substr(0,3) == 'id_' && campo.substr(-4,4) != '_mae' ) { 
                return '/audits/' + _.camelCase(campo.substr(3)) + '/' + valor;
            }

            return null;
        },

        log () { 
            console.log(this.dados);
        },

        load () { 
            this.$util.load(this, { 
                service: 'audits',
                parms: { 
                    model: this.model,
                    id: this.id, 
                }
            });
        },

        redirect (model, id) { 

            this.stack.push({ 
                model: this.model,
                id: this.id, 
                title: this.dados.title,
            });

            this.dados = null;
            this.model = model;
            this.id = id;

            this.load();

        }
    },

    mounted () { 

        console.log('params', this.$route.params);

        this.model = this.$route.params.model;
        this.id = this.$route.params.id;

        if ( this.$route.params.parms && this.$route.params.parms.campos ) {
            this.campos = this.$route.params.parms.campos;
        }

        this.load (); 

        let bc = this.$store.state.breadcrumb;

        if ( bc.length > 0 && !bc.find(item => item.name == 'Log de Alterações') ) { 
            bc.push({ name: 'Log de Alterações', path: "" });
            this.$store.commit('setBreadcrumb', bc);
        }

    }
}
</script>